import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=bbd489dc&scoped=true&"
import script from "./ReportHistory.vue?vue&type=script&lang=js&"
export * from "./ReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistory.vue?vue&type=style&index=0&id=bbd489dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd489dc",
  null
  
)

export default component.exports